<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/config/craft/approval/page"
      getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingchen')">
            <el-input v-model="yt.conditions.equipmentName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" v-if="utils.checkPower('web_process_distribution_config_craft_approval_batchInsert')" @click="
      yt.showEditDialog('xinzeng', null, 'w1');
    setDefaultValue();
    getProcedureCode();
    " type="primary">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
          @click="yt.showColumnsDialog()"></el-button>
      </template>


      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_process_distribution_config_craft_approval_batchInsert')"
                       @click=" yt.showEditDialog('bianji', scope.row, 'w1');
            setDefaultValue2(scope.row);
            getProcedureCode();
            ">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" v-if="utils.checkPower('web_process_distribution_config_craft_approval_delete')"
              @click="yt.remove(scope.row, '/custom/config/craft/approval/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_cross_select multiple :component="'web_base_equipment_list'" :ids.sync="yt.editObj.equipmentId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('shifoushenpi')" required>
            <el-select v-model="yt.editObj.approval">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>

          </el-form-item>
          <el-form-item :label="$t('shenpiren')" required>
            <yi_cross_select :max="1" :component="'web_system_user_list'" :ids.sync="yt.editObj.approver">
            </yi_cross_select>

          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini"
            @click="yt.req('POST', '/custom/config/craft/approval/batchInsert')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_cross_select multiple :component="'web_base_equipment_list'" :ids.sync="yt.editObj.equipmentId"
              disabled>
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('shifoushenpi')" required>

            <el-select v-model="yt.editObj.approval" required>
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shenpiren')" required>
            <yi_cross_select :max="1" :component="'web_system_user_list'" :ids.sync="yt.editObj.approver">
            </yi_cross_select>

          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini"
            @click="yt.req('POST', '/custom/config/craft/approval/batchInsert', beforeUpdate)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 导入excel -->
    <import-excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
// import importExcel from './import_excel'
export default {
  name: 'web_label_management_label_rule_list',
  components: {
    // importExcel
  },
  data() {
    return {
      moveButton: true,
      currentRow: null,
      value: '',
      labelRuleDetailsVOList: [],
      multipleSelection: [],
      show: false,
      codeAndDesc: '',
      columns: [
        {
          label: 'shebeimingchen',
          prop: 'equipment.name',
          width: 180
        },
        {
          label: 'shifoushenpi',
          prop: 'approval',
          type: 'bool',
          iln18: ['shi', 'fou'],
          width: 180
        },
        {
          label: 'shenpiren',
          prop: 'approverObject.nickname'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
					orderBy: 'createTime desc',
				}
      console.log(this.yt.get(1));
      this.yt.get(1);
      this.utils.event_hub.$on('QUALITY_MANAGEMENT_METHOD_REFRESH', () => {
        this.yt.get(1);
      });
    }, 300);
  },
  methods: {
    beforeUpdate(params) {
      params.equipmentId = [params.equipmentId]
      return params;
    }
  }
};
</script>
